import { useCallback, useContext } from "react";
import { RevisaoContratoContext } from "../contexts/RevisaoContratoContext";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import {
  createClienteContrato,
  getViewLists,
} from "../../../../repositories/qerpapi/erp/faturamento/RevisaoContrato";
import MaskService from "../../../../utils/mask/maskService";
import { notify } from "../../../../utils/notify";
import { validNotNull } from "../../../../utils/validations";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { findClientsContractsResumeV3 } from "../../../../repositories/qerpapi/v3/faturamento/ContratoRepository";

const useRevisaoContratoController = () => {
  const { queryParams } = useContext(QueryParamsContext);
  const {
    clientList,
    setClientList,
    setIsSelectingClients,
    currentClientIndex,
    setCurrentClientIndex,
    setBanksList,
    setServicesList,
    setReadjustsList,
    setDirections,
    setDisplayContent,
    vigency,
    setVigency,
    setViewLoading,
    service,
    readjust,
    bank,
    deadline,
    value,
    billType,
    NFSeType,
    setService,
    setReadjust,
    setBank,
    setDeadline,
    dueDate,
    setDueDate,
    periodicity,
    setPeriodicity,
    setValue,
    setBillType,
    setNFSeType,
    setFinishScreen,
    banksList,
    servicesList,
    readjustsList,
    currentContractIndex,
    setCurrentContractIndex,
    setErrors,
    setCustomMessage,
    setKeepValues,
    keepValues,
    setContractTypesList,
    contractType,
    setContractType,
    currentDate,
    setCompetency,
    competencyExample,
    competency,
    setDisabledButton,
    setPaymentTypesList,
    paymentTypesList,
    contractTypesList,
    setCompetencyExample,
    listBillet,
    allSelected,
    urlObjects,
    setUrlObjects,
    clickNextPage,
    setClickNextPage,
    clickLastPage,
    setClickLastPage,
    setClickResponseTotal,
    issueType,
    setIssueType,
    applyBillingRule,
    setApplyBillingRule,
  } = useContext(RevisaoContratoContext);

  const { push } = useHistory();

  const columns = [
    {
      id: "cpfcnpj",
      label: "CPF/CNPJ",
      format: (value) =>
        value?.cpfcnpj &&
        MaskService.toMask(
          (value?.cpfcnpj || "").replace(/[^0-9]+/g, "").length === 11
            ? "cpf"
            : "cnpj",
          value?.cpfcnpj || ""
        ),
    },
    {
      id: "razao",
      label: "Razão",
    },
  ];

  const handleClickBack = () => {
    if (currentContractIndex > 0) {
      setCurrentContractIndex((current) => current - 1);
    } else {
      let currentClient;

      setCurrentClientIndex((current) => {
        currentClient = current === 0 ? current : current - 1;
        return currentClient;
      });

      setCurrentContractIndex(
        clientList[currentClient]?.contratos?.length > 0
          ? clientList[currentClient].contratos.length - 1
          : 0
      );
    }

    setDirections(["right", "left"]);
    setDisplayContent(false);
  };

  const setDefaultBillTypeOption = useCallback(
    (billType = null) => {
      const defaultBillType = billType || "hibrido";
      const defaultBillTypeOption = listBillet.find(
        (tipo) => tipo.value === defaultBillType
      );
      return defaultBillTypeOption;
    },
    [listBillet]
  );

  const handleClickNext = async (ignore = false) => {
    try {
      let copyClientList = JSON.parse(JSON.stringify(clientList));
      if (ignore) {
        if (
          allSelected &&
          clickNextPage <= clickLastPage &&
          currentClientIndex === copyClientList.length - 1
        ) {
          setViewLoading(true);

          const callback = await findClientsContractsResumeV3({
            perPage: "5",
            page: clickNextPage,
            filters: {
              contractType: urlObjects?.tipocontrato || "",
              document: urlObjects.cnpj || "",
              companyId: queryParams?.empresa_id ?? "",
              name: encodeURIComponent((urlObjects.razao || "").toLowerCase()),
            },
          });

          if (!callback?.success) {
            setViewLoading(false);
            return notify(
              "Não foi possível buscar o próximo cliente.",
              true,
              "error"
            );
          }

          copyClientList = [...copyClientList, ...callback.data];
          setClickNextPage((currentPage) => currentPage + 1);
          setViewLoading(false);
        }
        if (
          currentContractIndex <
          copyClientList[currentClientIndex]?.contratos?.length - 1
        )
          setCurrentContractIndex((current) => current + 1);
        else if (currentClientIndex !== copyClientList.length - 1) {
          setCurrentClientIndex((current) =>
            current < copyClientList.length ? current + 1 : current
          );
          setCurrentContractIndex(0);
        } else
          setTimeout(() => {
            setCustomMessage("Contratos gerados com sucesso!");
            setFinishScreen(true);
          }, 300);

        setDirections(["left", "right"]);
        setDisplayContent(false);
        setErrors({});

        if (!keepValues) resetInputs();

        copyClientList[currentClientIndex].contratos = [
          {
            idempresa: queryParams?.empresa_id ?? "",
            idusuario: queryParams?.usuario_id ?? "",
            idcliente: copyClientList[currentClientIndex]?.id ?? "",
            idservico: service?.id ?? "",
            idtipocontrato: contractType?.id ?? "",
            idtipopagamento:
              (paymentTypesList || []).sort((a, b) => {
                const date1 = a?.datahoraalteracao
                    ? new Date(a.datahoraalteracao)
                    : 1,
                  date2 = b?.datahoraalteracao
                    ? new Date(b.datahoraalteracao)
                    : 0;

                return date2 - date1;
              })[0]?.id ?? null,
            idtiporeajuste: readjust?.id ?? "",
            idagencia: bank?.id ?? "",
            modalidade: "R",
            reajusteperiod: periodicity || 1,
            total: MaskService.removeMaskDecimal(value) ?? "",
            vigencia_renovacao: vigency ?? "",
            datavencimento1: deadline,
            dia_vencimento: dueDate ?? "",
            flag_emitir_nfse: NFSeType ? 1 : 0,
            mes_competencia: competencyExample ?? null,
            regime_competencia: competency?.value ?? "atual",
            id_modelo_contrato: contractType?.contrato_modelo_id ?? 1,
            ignored: true,
            padrao_contrato_tipo_emissao_nfse: NFSeType && !issueType ? 1 : 0,
            applyBillingRule: applyBillingRule,
          },
        ];

        setClientList(copyClientList);
        return notify("Contrato ignorado.", true, "warning");
      }

      if (
        Array.isArray(clientList[currentClientIndex]?.contratos) &&
        copyClientList[currentClientIndex]?.contratos[currentContractIndex]
          ?.saved
      ) {
        if (
          currentContractIndex <
          copyClientList[currentClientIndex]?.contratos?.length - 1
        )
          setCurrentContractIndex((current) => current + 1);
        else if (currentClientIndex !== copyClientList.length - 1) {
          setCurrentClientIndex((current) =>
            current < copyClientList.length ? current + 1 : current
          );
          setCurrentContractIndex(0);
        }
        return;
      }

      let validations = validNotNull([
        { value: service, key: "service" },
        { value: readjust, key: "readjust" },
        { value: bank, key: "bank" },
        { value: vigency, key: "vigency" },
        { value: deadline, key: "deadline" },
        { value: contractType, key: "contractType" },
        { value: value, key: "value" },
      ]);

      if (MaskService.removeMaskDecimal(value) === 0) {
        validations.error = true;
        validations.errorsValidation = {
          ...validations.errorsValidation,
          value: "Digite o valor do contrato.",
        };
      }

      if (validations.error) {
        notify("Preencha os campos antes de continuar.");
        setErrors({ ...validations });
        return;
      }

      const newContract = {
        idempresa: queryParams?.empresa_id ?? "",
        idusuario: queryParams?.usuario_id ?? "",
        idcliente: copyClientList[currentClientIndex]?.id ?? "",
        idservico: service?.id ?? "",
        idtipocontrato: contractType?.id ?? "",
        idtipopagamento:
          (paymentTypesList || []).sort((a, b) => {
            const date1 = a?.datahoraalteracao
                ? new Date(a.datahoraalteracao)
                : 1,
              date2 = b?.datahoraalteracao ? new Date(b.datahoraalteracao) : 0;

            return date2 - date1;
          })[0]?.id ?? null,
        idtiporeajuste: readjust?.id ?? "",
        idagencia: bank?.id ?? "",
        modalidade: "R",
        reajusteperiod: periodicity || 1,
        total: MaskService.removeMaskDecimal(value) ?? "",
        vigencia_renovacao: vigency ?? "",
        datavencimento1: deadline,
        dia_vencimento: dueDate ?? "",
        flag_emitir_nfse: NFSeType ? 1 : 0,
        mes_competencia: competencyExample ?? null,
        regime_competencia: competency?.value ?? "atual",
        id_modelo_contrato: contractType?.contrato_modelo_id ?? 1,
        ignored: false,
        padrao_contrato_tipo_emissao_nfse: NFSeType && !issueType ? 1 : 0,
        applyBillingRule: applyBillingRule,
      };

      if (bank?.banco?.codigobanco === "000")
        newContract.tipo_boleto = billType?.value ?? "";

      setViewLoading(true);
      const callback = await createClienteContrato({
        empresa_cnpj: queryParams.empresa_cnpj,
        idEmpresa: queryParams.empresa_id,
        body: newContract,
      });

      if (!callback.success) {
        return notify(`Não foi possível criar o contrato. Tente novamente.`);
      }

      newContract.saved = true;
      copyClientList[currentClientIndex].contratos = [newContract];

      notify("Contrato criado com sucesso!", true, "success");

      if (
        allSelected &&
        clickNextPage <= clickLastPage &&
        currentContractIndex ===
          copyClientList[currentClientIndex]?.contratos?.length - 1 &&
        currentClientIndex === copyClientList.length - 1
      ) {
        setViewLoading(true);
        const callback = await findClientsContractsResumeV3({
          perPage: "5",
          page: clickNextPage,
          filters: {
            contractType: urlObjects?.tipocontrato || "",
            document: urlObjects.cnpj || "",
            companyId: queryParams?.empresa_id ?? "",
            name: encodeURIComponent((urlObjects.razao || "").toLowerCase()),
          },
        });

        if (!callback?.success) {
          setClientList(copyClientList);
          setViewLoading(false);
          return notify(
            "Não foi possível buscar o próximo cliente. Tente novamente.",
            true,
            "error"
          );
        }

        copyClientList = [...copyClientList, ...callback.data];

        setClickNextPage((currentPage) => currentPage + 1);
        setViewLoading(false);
      }

      setClientList(copyClientList);

      if (
        currentContractIndex <
        copyClientList[currentClientIndex]?.contratos?.length - 1
      )
        setCurrentContractIndex((current) => current + 1);
      else if (currentClientIndex !== copyClientList.length - 1) {
        setCurrentClientIndex((current) =>
          current < copyClientList.length ? current + 1 : current
        );
        setCurrentContractIndex(0);
      } else
        setTimeout(() => {
          setCustomMessage("Contratos gerados com sucesso!");
          setFinishScreen(true);
        }, 300);

      setDirections(["left", "right"]);
      setDisplayContent(false);
      setErrors({});

      if (!keepValues) resetInputs();
    } catch (e) {
      console.error(e);
      notify(
        "Não foi possível armazenar as informações do contrato. Por favor tente novamente. Caso o problema persista entre em contato com o suporte!"
      );
    } finally {
      setViewLoading(false);
    }
  };

  const setContractData = useCallback(
    (contract = null) => {
      if (!contract || (keepValues && !contract.saved)) return;

      const {
        vigencia_renovacao,
        datavencimento1,
        flag_emitir_nfse,
        total,
        regime_competencia,
        idtipocontrato,
        idtiporeajuste,
        dia_vencimento,
      } = contract;

      setValue(
        MaskService.toMask(
          "decimal",
          total ? parseFloat(total).toFixed(2) : 0.0
        )
      );
      setVigency(vigencia_renovacao ?? "");
      setDeadline(datavencimento1 ?? "");
      setDueDate(dia_vencimento ?? "");
      setPeriodicity(contract?.reajusteperiod ?? "");
      setNFSeType(flag_emitir_nfse?.toString() === "1");
      setIssueType(contract?.padrao_contrato_tipo_emissao_nfse === 0);
      setApplyBillingRule(!!contract?.regua_cobranca_id);

      let competency = [
        {
          label: "Competência e Vencimento no mesmo mês",
          value: "atual",
        },
        {
          label: "Competência em mês anterior ao Vencimento",
          value: "anterior",
        },
        {
          label: "Competência em mês posterior ao Vencimento",
          value: "posterior",
        },
      ].find((e) => e.value === regime_competencia) || {
        label: "Competência e Vencimento no mesmo mês",
        value: "atual",
      };

      setCompetency(competency);
      setCompetencyExample(
        returnCompetencyAndVigency({
          competency: competency?.value,
          deadline: datavencimento1 ?? currentDate,
        }).competencyExample
      );

      let bankId = contract?.idagencia || null,
        bill = contract?.tipo_boleto || null;

      if (bankId) setBank(banksList.find((e) => e.id === bankId) || null);

      if (bill) {
        let defaultBillTypeOption = setDefaultBillTypeOption(bill);
        setBillType(defaultBillTypeOption);
      }

      if (idtipocontrato)
        setContractType(
          contractTypesList.find((e) => e.id === idtipocontrato) || null
        );

      setReadjust(readjustsList.find((e) => e.id === idtiporeajuste) || null);

      setService(servicesList.find((e) => e.id === contract.idservico) || null);
    },
    [
      currentDate,
      setCompetency,
      setDeadline,
      setNFSeType,
      setDueDate,
      setPeriodicity,
      setValue,
      setVigency,
      banksList,
      setBank,
      setDefaultBillTypeOption,
      setBillType,
      setContractType,
      contractTypesList,
      readjustsList,
      setReadjust,
      servicesList,
      setService,
      setCompetencyExample,
      keepValues,
      setIssueType,
    ]
  );

  const getData = useCallback(
    async ({ setLoading, empresa_cnpj, empresa_id, usuario_id }) => {
      const errorsObject = {
        error: false,
        messages: [],
      };

      try {
        setLoading(true);

        const result = await getViewLists({
          empresa_cnpj: empresa_cnpj,
          idEmpresa: empresa_id,
          idUsuario: usuario_id,
        });

        if (!result.success) {
          errorsObject.error = true;
          errorsObject.messages.push(
            "Ocorreu um erro ao buscar as informações, tente recarregar a página."
          );
        }

        if (!result.data?.agencias?.length) {
          errorsObject.error = true;
          errorsObject.messages.push(
            "Nenhum banco encontrado. Você precisa de ao menos um banco cadastrado."
          );
        }

        if (!result.data?.servicos?.length) {
          errorsObject.error = true;
          errorsObject.messages.push(
            "Nenhum tipo de serviço recorrente encontrado. Você precisa de ao menos um tipo de serviço cadastrado e vinculado a empresa."
          );
        }

        if (!result.data?.indices?.length) {
          errorsObject.error = true;
          errorsObject.messages.push(
            "Nenhum tipo de reajuste encontrado. Você precisa de ao menos um cadastrado e vinculado a empresa."
          );
        }

        if (!result.data?.tiposcontratos?.length) {
          errorsObject.error = true;
          errorsObject.messages.push(
            "Nenhuma classificação de contrato encontrada. Você precisa de ao menos um cadastrado, vinculado a empresa e ativo."
          );
        }

        if (!result.data?.tipospagto?.length) {
          errorsObject.error = true;
          errorsObject.messages.push(
            'Nenhum tipo de pagamento "boleto" cadastrado e/ou ativo no sistema.'
          );
        }

        setBanksList(result.data?.agencias ?? []);
        setServicesList(result.data?.servicos ?? []);
        setReadjustsList(result.data?.indices ?? []);
        setContractTypesList(result.data?.tiposcontratos ?? []);
        setPaymentTypesList(result.data?.tipospagto ?? []);

        if (errorsObject.error) {
          errorsObject.messages.forEach((message) => notify(message, false));

          setDisabledButton(true);

          return notify(
            "Devido ao(s) erro(s), não será possível utilizar a Geração/Revisão de contratos.",
            false
          );
        }
      } catch (e) {
        console.error("erro ao buscar listas: ", e);
      } finally {
        setLoading(false);
      }
    },
    [
      setBanksList,
      setServicesList,
      setReadjustsList,
      setDisabledButton,
      setContractTypesList,
      setPaymentTypesList,
    ]
  );

  const handleFinishSelecting = async () => {
    if (!clientList?.length)
      return notify(
        "Você precisa selecionar ao menos um cliente para continuar."
      );
    var clientsWithActiveContracs = "";
    clientList?.forEach((cliente) => {
      var clientName = "";
      cliente.contratos?.forEach((contrato) => {
        if (
          contrato.status === "A" &&
          contrato.modalidade === "R" &&
          clientName.length === 0
        ) {
          clientName = `<li>${cliente.apelido}</li>`;
        }
      });
      clientsWithActiveContracs += clientName;
    });

    try {
      let nextStep = false;
      let copyClientList = JSON.parse(JSON.stringify(clientList));

      if (
        allSelected &&
        (urlObjects?.tipocontrato === "" || urlObjects?.tipocontrato === "R")
      ) {
        setViewLoading(true);
        const callback = await findClientsContractsResumeV3({
          paginate: 0,
          filters: {
            contractType: "R",
            document: urlObjects?.cnpj || "",
            companyId: queryParams?.empresa_id ?? "",
            name: encodeURIComponent((urlObjects?.razao || "").toLowerCase()),
          },
        });

        if (!callback.success)
          notify(
            "Não foi possível verificar se o(s) cliente(s) já possui contrato recorrente ativo.",
            true,
            "error"
          );

        copyClientList = callback.data;
      }

      nextStep = await handleRecurringContractMsg(copyClientList || []);

      if (!nextStep) return setViewLoading(false);

      if (allSelected) {
        setViewLoading(true);

        const callback = await findClientsContractsResumeV3({
          perPage: "5",
          page: clickNextPage,
          filters: {
            contractType: urlObjects?.tipocontrato || "",
            document: urlObjects?.cnpj || "",
            companyId: queryParams?.empresa_id ?? "",
            name: encodeURIComponent((urlObjects?.razao || "").toLowerCase()),
          },
        });

        if (!callback?.success) {
          setViewLoading(false);
          return notify(
            "Não foi possível carregar o(s) cliente(s).",
            true,
            "error"
          );
        }
        setClientList(callback.data);
        setClickLastPage(callback?.paginate?.last_page || 0);
        setClickNextPage((currentPage) => currentPage + 1);
        setViewLoading(false);
        setClickResponseTotal(callback?.paginate?.total || 0);
      }

      resetInputs();
      setIsSelectingClients(false);
    } catch (e) {
      console.error(e);
      notify(
        "Não foi possível carregar a próxima etapa. Se o problema persistir entre em contato com o suporte!",
        true,
        "error"
      );
    } finally {
      setViewLoading(false);
    }
  };

  const resetInputs = () => {
    setVigency("");
    setService(null);
    setReadjust(null);
    setBank(null);
    setDeadline(currentDate);
    setValue("0,00");

    let defaultBillTypeOption = setDefaultBillTypeOption(null);
    setBillType(defaultBillTypeOption);

    setNFSeType(true);
    setContractType(null);
    setCompetency({
      label: "Competência e Vencimento no mesmo mês",
      value: "atual",
    });
    setIssueType(true);
    setApplyBillingRule(true);
  };

  const handleClickReset = () => {
    setClientList([]);
    setIsSelectingClients(true);
    setCurrentClientIndex(0);
    setCurrentContractIndex(0);
    setFinishScreen(false);
    setKeepValues(true);
    resetInputs();
    setClickLastPage(1);
    setClickNextPage(1);
    setClickResponseTotal(0);
    setUrlObjects({
      tipocontrato: "",
      cnpj: "",
      razao: "",
      empresa_id: queryParams?.empresa_id ?? "",
    });

    setCustomMessage("");
    setDirections(["left", "right"]);
  };

  const handleClose = async () => {
    await Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja sair?",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
      confirmButtonText: "Sim",
    }).then((result) => {
      if (result.isConfirmed)
        return push("/faturamento/gerenciamentocontrato/faturamento");
    });
  };

  const returnCompetencyAndVigency = ({ competency, deadline }) => {
    if (!competency || !deadline) {
      console.error("Nenhum regime de competência ou vencimento informado.");
      return {
        competencyExample: ``,
        vigency: ``,
      };
    }

    let yearFromDeadline = deadline.split("-")[0],
      monthByDeadline = deadline.split("-")[1];

    const currentCompetency = () => ({
      competencyExample: `${monthByDeadline}/${yearFromDeadline}`,
      vigency: `${monthByDeadline}/${parseInt(yearFromDeadline) + 1}`,
    });

    const previousCompetency = () => {
      let newYearFromDeadline =
          parseInt(monthByDeadline) - 1 === 0
            ? parseInt(yearFromDeadline) - 1
            : parseInt(yearFromDeadline),
        newMonthFromDeadline = (
          parseInt(monthByDeadline) - 1 === 0
            ? 12
            : parseInt(monthByDeadline) - 1
        )
          .toString()
          .padStart(2, "0");

      return {
        competencyExample: `${newMonthFromDeadline}/${newYearFromDeadline}`,
        vigency: `${newMonthFromDeadline}/${newYearFromDeadline + 1}`,
      };
    };

    const nextCompetency = () => {
      let newYearFromDeadline =
          parseInt(monthByDeadline) + 1 === 13
            ? parseInt(yearFromDeadline) + 1
            : parseInt(yearFromDeadline),
        newMonthFromDeadline = (
          parseInt(monthByDeadline) + 1 === 13
            ? 1
            : parseInt(monthByDeadline) + 1
        )
          .toString()
          .padStart(2, "0");

      return {
        competencyExample: `${newMonthFromDeadline}/${newYearFromDeadline}`,
        vigency: `${newMonthFromDeadline}/${newYearFromDeadline + 1}`,
      };
    };

    const competencies = (index) =>
      ({
        atual: currentCompetency,
        anterior: previousCompetency,
        posterior: nextCompetency,
      }[index]());

    return competencies(competency);
  };

  const handleManagement = () => {
    push("/faturamento/gerenciamentocontrato/listagem");
  };

  const handleRecurringContractMsg = async (clientList = []) => {
    let nextStep = true;

    let clientsWithActiveContracs = "";

    clientList.forEach((client) => {
      if (client.hasRecurrentContract) {
        clientsWithActiveContracs += `<li>${client.clientName}</li>`;
      }
    });

    const divUlStyle = "max-height:100px;overflow-y:scroll;font-size: 0.8rem;";

    if (clientsWithActiveContracs.length) {
      await Swal.fire({
        icon: "question",
        title:
          '<p style="font-size: 1rem;">O(s) Cliente(s) já possui contrato recorrente ativo. Ao continuar irá gerar um novo contrato recorrente para esse cliente.</p>',
        html: `<div style="${divUlStyle}"><ul style="list-style: none;margin:0;">${clientsWithActiveContracs}</ul></div><p style="font-size: 1rem;margin:5px 0 0 0;">Deseja Continuar?</p>`,
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (!result.isConfirmed) {
          nextStep = false;
        }
      });
    }

    return nextStep;
  };

  return {
    columns,
    getData,
    handleClose,
    resetInputs,
    setContractData,
    handleClickBack,
    handleClickNext,
    handleClickReset,
    handleFinishSelecting,
    returnCompetencyAndVigency,
    handleManagement,
  };
};

export default useRevisaoContratoController;
